import React, { useState } from 'react';
import Select from '../../../../reusables/Select';
import Processing from '@/presentation/components/Processing';
import CheckBox from '../../../procedures/modules/scholarships/bse/components/CheckBox';
import { SaveButton } from '../../../procedures/modules/scholarships/bse/components/styled';
import OpeningHours from '../../components/openingHours/openingHours';
import {
  Wrapper,
  WrapperCard,
  WrapperCardDescription,
  WrapperCardGrid,
  WrapperCheckbox
} from './styled';

import ModalComplete from './modals/complete';
import ModalConfirm from './modals/confirm';
import ModalError from './modals/Error';
import ModalSorry from './modals/Sorry';
import ModalSorry2 from './modals/Sorry2';
import ModalConfirmation from '../../../procedures/components/Modal/Modal';
import ConfirmationQuit from '../../../procedures/modules/requests/UpdatePhoto/Register/components/ConfirmationQuit';
import EmbeddedViewController from '../embedded/EmbeddedViewController';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import Link from '@/presentation/reusables/Link';
import PopPupRestriction from '@/presentation/reusables/PopRestriction';
import { Icon } from '@/presentation/components';

interface IProps {
  dataCampus: any[];
  dataLibraries: any[];
  dataDates: any[];
  dataHours: any[];
  dataDurations: any[];

  resourceType: { isTablet: boolean; isComputer: boolean; isRoom: boolean };
  selectCampus: any;
  selectLibrary: any;
  selectDate: any;
  selectHour: any;
  selectDuration: any;

  isCancel: boolean;
  isCheck: boolean;
  isComplete: boolean;
  isError: boolean;
  isLoadingDates: boolean;
  isProcessing: boolean;
  isSorry: boolean;
  isSorry2: boolean;
  isValid: boolean;
  restriction: boolean;

  setIsCancel: (v: any) => void;
  setIsCheck: (v: any) => void;
  setIsError: (v: any) => void;
  setIsSorry: (v: any) => void;
  setIsSorry2: (v: any) => void;
  handlerRedirectToDetail: () => void;
  handlerBackConfirm: () => void;
  handlerData: (option: string, obj: any) => void;
  handlerSubmit: () => void;
  setRestriction: (show: boolean) => void;
  openingHours: any;
}

const ReservationRegisterView = ({
  restriction,
  dataCampus,
  dataLibraries,
  dataDates,
  dataHours,
  dataDurations,

  resourceType,
  selectCampus,
  selectLibrary,
  selectDate,
  selectHour,
  selectDuration,

  isCancel,
  isCheck,
  isComplete,
  isError,
  isLoadingDates,
  isProcessing,
  isSorry,
  isSorry2,
  isValid,

  setIsCancel,
  setRestriction,
  setIsCheck,
  setIsError,
  setIsSorry,
  setIsSorry2,
  handlerRedirectToDetail,
  handlerBackConfirm,
  handlerData,
  handlerSubmit,
  openingHours
}: IProps) => {
  const [isConfirm, setIsConfirm] = useState<boolean>(false);
  const url = resourceType.isTablet
    ? 'https://drive.google.com/file/d/1vul4VKiXkyL1HnhyuMlABXXdQcGp1Qu1/view'
    : 'https://bit.ly/PoliticasPrestamoComputadoras';

  return (
    <Wrapper data-testid="cmp-wrapper-reservation-register">
      {resourceType.isRoom && (
        <EmbeddedViewController
          ButtonBackEnabled={false}
          containerEnabled={false}
        />
      )}
      {!resourceType.isRoom && (
        <>
          <Processing isOpen={isProcessing} />
          <WrapperCard>
            {resourceType.isTablet && (
              <WrapperCardDescription>
                <p>Escoge el lugar donde recogerías tu recurso.</p>
                <p>
                  <b>Recuerda:</b> Acércarte con tu carné SUNEDU o DNI + Carné
                  UTP en físico o virtual. El uso es exclusivo dentro del
                  campus.
                </p>
              </WrapperCardDescription>
            )}
            {resourceType.isComputer && (
              <WrapperCardDescription>
                <p>Escoge el lugar donde reservarías la computadora.</p>
                <p>
                  <b>Recuerda:</b> Acércarte con tu carné SUNEDU o DNI + carné
                  UTP en físico o virtual.
                </p>
              </WrapperCardDescription>
            )}
            <WrapperCardGrid>
              <Select
                itemCount={4}
                itemName="name"
                items={dataCampus}
                itemValue="id"
                label="Campus:"
                placeholder="Seleccionar"
                returnObject
                value={selectCampus}
                onChange={(v) => {
                  handlerData('campus', v);
                }}
              />
              <Select
                itemCount={4}
                itemName="name"
                items={dataLibraries}
                itemValue="id"
                label="Biblioteca:"
                placeholder="Seleccionar"
                returnObject
                value={selectLibrary}
                onChange={(v) => {
                  handlerData('library', v);
                }}
              />
              <Select
                isLoading={isLoadingDates}
                itemCount={4}
                itemName="name"
                items={dataDates}
                itemValue="id"
                label="Fechas disponibles:"
                placeholder="Seleccionar"
                returnObject
                value={selectDate}
                onChange={(v) => {
                  handlerData('date', v);
                }}
                isDisabled={dataDates.length === 0}
              />
              {dataDates.length === 0 && (
                <p
                  data-testid="paragraph-disabled"
                  style={{
                    color: '#4F6168',
                    fontSize: 12,
                    fontFamily: 'Lato',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4
                  }}
                >
                  <Icon name="info" size={15} color="#977100" />
                  {' No hay fecha disponible para esta biblioteca.'}
                </p>
              )}
              {selectDate ? (
                <OpeningHours
                  hourStart={openingHours?.hourStart}
                  hourEnd={openingHours?.hourEnd}
                />
              ) : (
                <div> </div>
              )}
              <Select
                isLoading={isLoadingDates}
                itemCount={4}
                itemName="hour"
                items={dataHours}
                itemValue="timestamp"
                label="Hora de inicio:"
                placeholder="00:00"
                returnObject
                value={selectHour}
                onChange={(v) => {
                  handlerData('hour', v);
                }}
                isDisabled={dataDates.length === 0}
              />
              <Select
                isLoading={isLoadingDates}
                itemCount={4}
                itemName="name"
                items={dataDurations}
                itemValue="hour"
                label="Duración:"
                placeholder="0 horas"
                returnObject
                value={selectDuration}
                onChange={(v) => {
                  handlerData('duration', v);
                }}
                isDisabled={dataDates.length === 0}
              />
              <WrapperCheckbox disabled={dataDates.length === 0}>
                <CheckBox
                  disabled={dataDates.length === 0}
                  value="1"
                  firstLabel=""
                  handleOnChange={() => {
                    setIsCheck(!isCheck);
                  }}
                />
                <span>
                  Aceptar{' '}
                  <Link
                    linkType="external"
                    url={url}
                    linkName="términos y condiciones"
                  />
                </span>
              </WrapperCheckbox>
              <div>
                <SaveButton
                  data-testid="cmp-save-button"
                  disabled={!isValid}
                  onClick={() => {
                    GoogleAnalytics.writeLog(
                      `portal-services-reserve${
                        resourceType.isTablet ? 'Tablet' : 'Computer'
                      }`,
                      'services'
                    );
                    setIsConfirm(true);
                  }}
                >
                  Reservar
                </SaveButton>
              </div>
            </WrapperCardGrid>
          </WrapperCard>
          <ModalConfirm
            campus={selectCampus}
            date={selectDate}
            duration={selectDuration}
            hour={selectHour}
            library={selectLibrary}
            show={isConfirm}
            handlerClose={() => setIsConfirm(false)}
            handlerConfirm={() => {
              setIsConfirm(false);
              handlerSubmit();
            }}
            resourceType={resourceType}
          />
          {/* confirmacion */}
          <ModalComplete
            show={isComplete}
            handlerClose={() => handlerRedirectToDetail()}
          />
          {/* generico */}
          <ModalError show={isError} handlerClose={() => setIsError(false)} />
          {/* turno */}
          <ModalSorry show={isSorry} handlerClose={() => setIsSorry(false)} />
          {/* cruce */}
          <ModalSorry2
            show={isSorry2}
            handlerClose={() => setIsSorry2(false)}
          />
          <ModalConfirmation
            show={isCancel}
            handleClose={() => setIsCancel(false)}
          >
            <ConfirmationQuit
              handleQuit={() => handlerBackConfirm()}
              handleCancel={() => setIsCancel(false)}
            />
          </ModalConfirmation>
          <ModalConfirmation
            show={restriction}
            handleClose={() => setRestriction(false)}
          >
            <PopPupRestriction handleClick={() => setRestriction(false)} />
          </ModalConfirmation>
        </>
      )}
    </Wrapper>
  );
};

export default ReservationRegisterView;
